import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';

export interface GameSwitchUpdateSessionContext {
  region: string;
  brand: string;
  updateSessionURL: string;
  isJackpotModeActive: boolean;
}

/** Ported from casino-game-launcher's ddActionGameSwitchUpdateSession. */
export const ddActionGameSwitchUpdateSession = (
  context: GameSwitchUpdateSessionContext,
) =>
  Logger.logRumAction({
    name: 'UPDATE_SESSION',
    description: 'Update session on game switch',
    useCase: DdEventCategory.GameSwitch,
    eventType: DdEventType.Action,
    context: { ...context },
  });
